import ModalSuppliers from './ModalSuppliers'

export default ModalSuppliers
